<form class="c-form" #mainForm="ngForm" name="vm.form">
	<div class="o-grid o-grid--wrap@up-to-md o-grid--center-h" [ngStyle]="vm.loading && {'min-height': '254px', 'position': 'relative'}">
		<!-- User data: image -->
		<div class="o-grid__cell o-grid__cell--w-fixed u-no-pl u-osb-xl u-no-p@up-to-md" *ngIf="vm.initialized">
			<avatar [user]="vm.booking.user"></avatar>
		</div>
		<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fit@md-and-up u-no-pr u-no-p@up-to-md" *ngIf="vm.initialized">
			<!-- User data: general -->
			<p class="c-text c-text--bold c-text--lg u-osb-sm">{{ vm.booking.user.firstname }} {{ vm.booking.user.lastname }}</p>
			<p class="c-text c-text--bold u-osb-sm">{{ vm.booking.comment }}</p>
			<div class="o-grid u-osb-xs" *ngIf="vm.booking.careTakenInfo?.name">
				<div class="o-grid__cell o-grid__cell--slim u-no-pl">
					<p class="c-text c-text--gray">{{ 'Booking.Form.Label.Patient_Name' | translate }}</p>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
					<p id="careTakenNameLabel" class="c-text c-text--right">{{ vm.booking.careTakenInfo?.name }}</p>
				</div>
			</div>
			<div class="o-grid u-osb-xs" *ngIf="vm.booking.careTakenInfo?.name">
				<div class="o-grid__cell o-grid__cell--slim u-no-pl">
					<p class="c-text c-text--gray">{{ 'Booking.Form.Label.Patient_Personal_Code' | translate }}</p>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
					<p id="careTakenPersonalCodeLabel" class="c-text c-text--right">{{ vm.booking.careTakenInfo?.personalCode }}</p>
				</div>
			</div>
			<div class="c-divider c-divider--h c-divider--light" *ngIf="vm.booking?.careTakenInfo"></div>
			<div class="o-grid u-osb-xs" *ngIf="vm.booking.user.service?.title">
				<div class="o-grid__cell o-grid__cell--slim u-no-pl">
					<p class="c-text c-text--gray">{{ 'Booking.Institution' | translate }}</p>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
					<p class="c-text c-text--right">{{ vm.booking.user.service.title }}</p>
				</div>
			</div>
			<div class="o-grid u-osb-xs" *ngIf="vm.booking.user.personalCode">
				<div class="o-grid__cell o-grid__cell--slim u-no-pl">
					<p class="c-text c-text--gray">{{ 'Booking.Personal_Code' | translate }}</p>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
					<p class="c-text c-text--right">{{ vm.booking.user.personalCode }}</p>
				</div>
			</div>
			<div class="o-grid u-osb-xs" *ngIf="vm.isDoctor && !vm.booking.reservationLink">
	            <div class="o-grid__cell o-grid__cell--slim u-no-pl">
	                <p class="c-text c-text--gray">{{ 'Booking.Modal.TargetPlatform' | translate }}</p>
	            </div>
	            <div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
	                <p class="c-text c-text--right">{{ vm.booking.user.origin }}</p>
	            </div>
	        </div>
			<div class="o-grid u-osb-xs" *ngIf="!vm.booking.user.personalCode && vm.booking.user.userCode">
				<div class="o-grid__cell o-grid__cell--slim u-no-pl">
					<p class="c-text c-text--gray">{{ 'Booking.User_Code' | translate }}</p>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
					<p class="c-text c-text--right">{{ vm.booking.user.userCode }}</p>
				</div>
			</div>
			<div class="o-grid u-osb-xs" *ngIf="vm.booking.user.phoneNumber">
				<div class="o-grid__cell o-grid__cell--slim u-no-pl">
					<p class="c-text c-text--gray">{{ 'Modal.Form.Label.Phone_Number' | translate }}</p>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
					<p class="c-text c-text--right">{{ vm.booking.user.phone }}</p>
				</div>
			</div>
			<div class="o-grid u-osb-xs" *ngIf="vm.booking.user.contactInfo?.address || vm.booking.user.contactInfo?.city">
				<div class="o-grid__cell o-grid__cell--slim u-no-pl">
					<p class="c-text c-text--gray">{{ 'Booking.Location' | translate }}</p>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
					<p class="c-text c-text--right">{{ vm.booking.user.contactInfo.address }}<span *ngIf="vm.booking.user.contactInfo.address && vm.booking.user.contactInfo.city">, </span>{{ vm.booking.user.contactInfo.city }}</p>
				</div>
			</div>
			<div class="o-grid u-osb-xs" [hidden]="vm.booking.user.email == 'reserved@minudoc.ee'">
				<div class="o-grid__cell o-grid__cell--slim u-no-pl">
					<p class="c-text c-text--gray">{{ 'Modal.Form.Label.Email' | translate }}</p>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
					<p class="c-text c-text--right">{{ vm.booking.user.email }}</p>
				</div>
			</div>
			<div class="o-grid u-osb-xs" *ngIf="vm.isDoctor && vm.booking.reservationLink && vm.booking.status === 'RESERVED'">
				<div class="o-grid__cell o-grid__cell--slim u-no-pl">
					<p class="c-text c-text--gray">{{ 'Booking.Modal.ReservationLink' | translate }}</p>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
					<a href="javascript:void(0)" class="c-text c-text--right" (click)="vm.copyReservationLink($event)">{{ 'Booking.CopyReservationLink' | translate }}</a>
				</div>
			</div>
			<div class="o-grid u-osb-xs" *ngIf="vm.isDoctor && vm.booking.extraInfo?.businessClientSettings && vm.booking.extraInfo?.businessClientSettings.sessionLimit">
				<div class="o-grid__cell o-grid__cell--slim u-no-pl">
					<p class="c-text c-text--gray">{{ 'Booking.Sessions_Used' | translate }}</p>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
					<p class="c-text c-text--right">{{vm.booking.extraInfo.businessClientSettings.sessionsUsed ? vm.booking.extraInfo.businessClientSettings.sessionsUsed : 0}}/{{vm.booking.extraInfo.businessClientSettings.sessionLimit}}</p>
				</div>
			</div>
			<div class="c-divider c-divider--h c-divider--light" *ngIf="!vm.isAlt"></div>
			<!-- User data: recipe info -->
			<div *ngIf="vm.isPrescription && !vm.isWeightLossPrescription">
				<div class="o-grid u-osb-xs">
					<div class="o-grid__cell o-grid__cell--slim u-no-pl">
						<p class="c-text c-text--gray">{{ 'Booking.Prescription.Name' | translate }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
						<p id="prescriptionDescriptionLabel" class="c-text c-text--right c-text--wrap">{{ vm.getPrescriptionDescription() }}</p>
					</div>
				</div>
				<div class="o-grid u-osb-xs">
					<div class="o-grid__cell o-grid__cell--slim u-no-pl">
						<p class="c-text c-text--gray">{{ 'Booking.Prescription.Frequency' | translate }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
						<p class="c-text c-text--right">{{ vm.booking.bookingInstantRequest.prescriptionRequest.dosageFrequency || '-' }}</p>
					</div>
				</div>
				<div class="o-grid u-osb-xs">
					<div class="o-grid__cell o-grid__cell--slim u-no-pl">
						<p class="c-text c-text--gray">{{ 'Booking.Prescription.Usage' | translate }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
						<p class="c-text c-text--right">{{ ('Booking.Prescription.Usages.' + vm.booking.bookingInstantRequest.prescriptionRequest.prescriptionUsage) | translate }}</p>
					</div>
				</div>
				<div class="o-grid u-osb-xs">
					<div class="o-grid__cell o-grid__cell--slim u-no-pl">
						<p class="c-text c-text--gray">{{ 'Booking.Prescription.Effect' | translate }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
						<p class="c-text c-text--right">{{ ('Booking.Prescription.Effects.' + vm.booking.bookingInstantRequest.prescriptionRequest.prescriptionEffect) | translate }}</p>
					</div>
				</div>
				<div class="o-grid u-osb-xs">
					<div class="o-grid__cell o-grid__cell--slim u-no-pl">
						<p class="c-text c-text--gray">{{ 'Booking.Prescription.Expiry' | translate }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
						<p class="c-text c-text--right">{{ ('Booking.Prescription.Expiries.' + vm.booking.bookingInstantRequest.prescriptionRequest.prescriptionExpiry) | translate }}</p>
					</div>
				</div>
				<div class="o-grid u-osb-xs">
					<div class="o-grid__cell o-grid__cell--slim u-no-pl">
						<p class="c-text c-text--gray">{{ 'Booking.Prescription.Reason' | translate }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
						<p class="c-text c-text--right">{{ ('Booking.Prescription.Reasons.' + vm.booking.bookingInstantRequest.prescriptionRequest.prescriptionRequestReason) | translate }}</p>
					</div>
				</div>
				<div class="o-grid u-osb-xs">
					<div class="o-grid__cell o-grid__cell--slim u-no-pl">
						<p class="c-text c-text--gray">{{ 'Booking.Problem_Description' | translate }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
						<p class="c-text c-text--right">{{ vm.booking.bookingInstantRequest.prescriptionRequest.problemDescription || '-' }}</p>
					</div>
				</div>
				<div class="o-grid u-osb-xs">
					<div class="o-grid__cell o-grid__cell--slim u-no-pl">
						<p class="c-text c-text--gray">{{ 'Booking.Prescription.Side_Effects' | translate }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
						<p class="c-text c-text--right">{{ vm.booking.bookingInstantRequest.prescriptionRequest.sideEffects || '-' }}</p>
					</div>
				</div>
				<div class="c-divider c-divider--h c-divider--light"></div>
				<div class="o-grid u-osb-xs" *ngIf="vm.booking.status === 'DECLINED' || vm.booking.status === 'COMPLETED'">
					<div class="o-grid__cell o-grid__cell--slim u-no-pl">
						<p class="c-text c-text--gray">{{ 'Booking.Prescription.Number' | translate }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
						<p id="prescriptionNumberLabel" class="c-text c-text--right">{{ vm.prescriptionNumber || '-' }}</p>
					</div>
				</div>
				<div *ngIf="vm.isDoctor && vm.booking.status !== 'DECLINED' && vm.booking.status !== 'COMPLETED'">
					<div class="c-form__group" [ngClass]="{'c-form__group--error': vm.submitted && prescriptionNumber.invalid}">
						<label for="{{ 'prescription-' + vm.uid }}" class="c-form__label c-form__label--light">{{ 'Booking.Prescription.Number' | translate }}</label>
						<input type="text" name="{{ 'prescription-' + vm.uid }}" id="{{ 'prescription-' + vm.uid }}" class="c-form__input c-form__input--sm" [(ngModel)]="vm.prescriptionNumber" #prescriptionNumber="ngModel" required />
					</div>
					<div class="c-form__group u-osb-xs" [ngClass]="{'c-form__group--error': vm.submitted && dosageInstructions.invalid}">
						<label for="{{ 'dosageInstructions-' + vm.uid }}" class="c-form__label c-form__label--light">{{ 'Booking.Prescription.Dosage_Instructions' | translate }}</label>
						<textarea rows="5" id="{{ 'dosageInstructions-' + vm.uid }}" name="{{ 'dosageInstructions-' + vm.uid }}" class="c-form__input" [(ngModel)]="vm.dosageInstructions" #dosageInstructions="ngModel" maxlength="{{vm.dosageInstructionsMaxLength}}"></textarea>
						<p class="c-text c-text--sm c-text--right c-text--gray" [ngClass]="{ 'c-text--s3': vm.submitted && dosageInstructions?.errors?.maxlength }">{{ dosageInstructions?.value?.length || 0 }} / {{ vm.dosageInstructionsMaxLength }}</p>
					</div>
				</div>
			</div>
			<div *ngIf="vm.isWeightLossPrescription">
				<div class="o-grid u-osb-xs" *ngIf="vm.booking.status === 'DECLINED' || vm.weightLossPrescriptionNumber">
					<div class="o-grid__cell o-grid__cell--slim u-no-pl">
						<p class="c-text c-text--gray">{{ 'Booking.Prescription.Number' | translate }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
						<p id="weightLossPrescriptionNumberLabel" class="c-text c-text--right">{{ vm.weightLossPrescriptionNumber || '-' }}</p>
					</div>
				</div>
				<div *ngIf="vm.isDoctor && vm.booking.status !== 'DECLINED' && !vm.weightLossPrescriptionNumber">
					<p class="c-text ">{{ 'Booking.Prescription.Prescription_Info' | translate }}</p>
					<div class="c-form__group" [ngClass]="{'c-form__group--error': vm.submitted && weightLossPrescriptionNumberInput.invalid}" style="margin-top: 14px;">
						<label for="{{ 'weightLossPrescription-' + vm.uid }}" class="c-form__label c-form__label--light">{{ 'Booking.Prescription.Number' | translate }}</label>
						<input type="text" name="{{ 'weightLossPrescription-' + vm.uid }}" id="{{ 'weightLossPrescription-' + vm.uid }}" class="c-form__input c-form__input--sm" [(ngModel)]="vm.weightLossPrescriptionNumberInput" #weightLossPrescriptionNumberInput="ngModel" required />
					</div>
					<div class="c-form__group u-osb-xs" [ngClass]="{'c-form__group--error': vm.submitted && guidelines.invalid}">
						<label for="{{ 'guidelines-' + vm.uid }}" class="c-form__label c-form__label--light">{{ 'Booking.Prescription.Dosage_Instructions' | translate }}</label>
						<textarea rows="5" id="{{ 'guidelines-' + vm.uid }}" name="{{ 'guidelines-' + vm.uid }}" class="c-form__input" [(ngModel)]="vm.guidelines" #guidelines="ngModel" maxlength="{{vm.dosageInstructionsMaxLength}}"></textarea>
						<p class="c-text c-text--sm c-text--right c-text--gray" [ngClass]="{ 'c-text--s3': vm.submitted && guidelines?.errors?.maxlength }">{{ guidelines?.value?.length || 0 }} / {{ vm.dosageInstructionsMaxLength }}</p>
					</div>
				</div>
			</div>
			<!-- User data: booking info -->
			<div *ngIf="!vm.isPrescription && !vm.isWeightLossPrescription">
				<div class="o-grid u-osb-xs">
					<div class="o-grid__cell o-grid__cell--slim u-no-pl">
						<p class="c-text c-text--gray">{{ 'Booking.Service' | translate }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
						<p class="c-text c-text--right" data-testid="booking-communication-type" *ngIf="vm.isHomeVisit">{{ 'Booking.Home_Visit' | translate }}</p>
						<p class="c-text c-text--right" data-testid="booking-communication-type" *ngIf="!vm.isHomeVisit && vm.booking.communicationType">{{ 'Booking.CommunicationType.' + vm.booking.communicationType | translate }}</p>
					</div>
				</div>
				<div class="o-grid u-osb-xs" *ngIf="vm.booking.communicationType === 'FACE_TO_FACE' && vm.booking.bookingOfficeAddress">
					<div class="o-grid__cell o-grid__cell--slim u-no-pl">
						<p class="c-text c-text--gray">{{ 'Booking.Title.Address' | translate }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
						<p class="c-text c-text--right" data-testid="booking-office-address">{{vm.booking.bookingOfficeAddress}}</p>
					</div>
				</div>
				<div class="o-grid u-osb-xs">
					<div class="o-grid__cell o-grid__cell--slim u-no-pl">
						<p class="c-text c-text--gray">{{ 'Booking.Date' | translate }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
						<p class="c-text c-text--right">{{ vm.booking.date }}</p>
					</div>
				</div>
				<div class="o-grid u-osb-xs">
					<div class="o-grid__cell o-grid__cell--slim u-no-pl">
						<p class="c-text c-text--gray">{{ 'Booking.Time' | translate }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
						<p class="c-text c-text--right">{{ vm.booking.start }} - {{ vm.booking.end }} ({{ vm.booking.duration }} {{ 'Units.Minutes' | translate | lowerCase }})</p>
					</div>
				</div>
				<div class="o-grid u-osb-xs" *ngIf="vm.isDoctor">
					<div class="o-grid__cell o-grid__cell--slim u-no-pl">
						<p class="c-text c-text--gray">{{ 'Subscription.Placeholder.Price' | translate }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
						<p class="c-text c-text--right">{{ vm.booking.price.price || '-' }}{{ vm.booking.price.currency | currency }}</p>
					</div>
				</div>
				<div class="c-panel" panel [isOpen]="vm.notesVisible" *ngIf="vm.notesAllowed && vm.isDoctor">
					<div class="c-panel__content u-no-p">
						<div class="c-divider c-divider--h c-divider--light"></div>
						<div class="c-form__group u-osb-xs">
							<label for="{{ 'notes-' + vm.uid }}" class="c-form__label c-form__label--light">{{ 'Call.Content.Notes' | translate }}</label>
							<textarea rows="6" name="notes" id="{{ 'notes-' + vm.uid }}" class="c-form__input c-form__input--sm" #notesTextArea="ngModel" [(ngModel)]="vm.notes" maxlength="10000"></textarea>
						</div>
					</div>
				</div>
			</div>
		</div>
		<loader-overlay *ngIf="vm.loading" [theme]="vm.isAlt && 3"></loader-overlay>
	</div>
	<div class="u-ost-sm" *ngIf="vm.isDoctor">
		<div class="o-grid o-grid--wrap o-grid--xs o-grid--right" [ngClass]="{'u-opaque': vm.loading, 'u-hidden': !vm.initialized}">
			<div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-50 u-ost-xs u-osb-xs" *ngIf="!vm.notesVisible && !vm.isPrescription && !vm.isWeightLossPrescription">
				<button id="showNotesButton" class="c-button c-button--fit c-button--narrow" [ngClass]="{'c-button--s1': vm.isAlt, 'c-button--s6': !vm.isAlt, 'c-button--disabled': !vm.notesAllowed}" [disabled]="vm.loading || !vm.initialized" (click)="vm.showNotes()" title="{{ !vm.notesAllowed ? ('Services.Other.Notes_Disabled' | translate) : '' }}">{{ 'Call.Content.Notes_Placeholder' | translate }}</button>
			</div>
			<div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-50 u-ost-xs u-osb-xs" *ngIf="vm.isUpcomingStatus && !vm.isWeightLossPrescription">
				<button id="cancelBookingButton" class="c-button c-button--fit c-button--narrow" [ngClass]="{'c-button--s1': vm.isAlt, 'c-button--s6': !vm.isAlt}" [disabled]="vm.loading || !vm.initialized" (click)="vm.handleBookingCancel()">{{ (vm.isPrescription ? 'Booking.Prescription.Cancel' : 'Modal.Button.Cancel_Booking') | translate }}</button>
			</div>
			<div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-50 u-ost-xs u-osb-xs" *ngIf="!vm.isPrescription && vm.isUpcomingStatus && !vm.isWeightLossPrescription">
				<button id="rescheduleBookingButton" class="c-button c-button--fit c-button--narrow" [ngClass]="{'c-button--s1': vm.isAlt, 'c-button--s6': !vm.isAlt}" [disabled]="vm.loading || !vm.initialized" (click)="vm.handleRescheduleModalOpen()">{{ 'Booking.Reschedule' | translate }}</button>
			</div>
			<div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-50 u-ost-xs u-osb-xs" *ngIf="vm.notesVisible && vm.isTherapyFundBooking() && !vm.isSentToTherapyFund()">
				<button id="therapyFundNotesButton" class="c-button c-button--fit c-button--narrow" [ngClass]="{'c-button--s2': vm.isAlt, 'c-button--s1': !vm.isAlt}" (click)="vm.sendTherapyFundNotes()">{{ 'TherapyFundWallet.Send_Notes' | translate }}</button>
			</div>
			<div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-50 u-ost-xs u-osb-xs" *ngIf="!vm.isPrescription && !vm.isWeightLossPrescription || (vm.isPrescription && vm.booking.status !== 'DECLINED' && vm.booking.status !== 'COMPLETED')">
				<button id="bookingUpdateSubmitButton" class="c-button c-button--fit c-button--narrow" [ngClass]="{'c-button--s2': vm.isAlt, 'c-button--s1': !vm.isAlt}" [disabled]="vm.loading || !vm.initialized" (click)="vm.handleFormSubmit(mainForm)">{{ (vm.isPrescription ? 'Booking.Prescription.Extend' : 'Modal.Button.Save') | translate }}</button>
			</div>
			<div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-100 u-ost-xs u-osb-xs" *ngIf="!vm.isWeightLossPrescription && !vm.isPrescription && (vm.booking.status !== 'COMPLETED' && vm.booking.status !== 'DECLINED') && vm.isWeightLossSupportedDoctor">
				<button id="sendQuestionnaireButton" class="c-button c-button--fit c-button--narrow" [ngClass]="{'c-button--s2': vm.isAlt, 'c-button--s1': !vm.isAlt}" [disabled]="vm.loading || !vm.initialized" (click)="vm.handleQuestionnaireSend()">{{ 'Booking.Modal.Send_Questionnaire' | translate }}</button>
			</div>
			<div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-50 u-ost-xs u-osb-xs" *ngIf="!vm.isWeightLossPrescription && !vm.isPrescription && !vm.isUpcomingStatus && vm.booking.status !== 'DECLINED' && vm.weightLossPrescriptionNumber || (vm.isWeightLossPrescription && vm.booking.status !== 'DECLINED' && !vm.weightLossPrescriptionNumber)">
				<button id="savePrescriptionButton" class="c-button c-button--fit c-button--s6 c-button--narrow" [disabled]="vm.loading || !vm.initialized" (click)="vm.handleFormSubmit(mainForm, false)">{{ 'Modal.Button.Save' | translate }}</button>
			</div>
			<div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-50 u-ost-xs u-osb-xs" *ngIf="!vm.isWeightLossPrescription && !vm.isPrescription && !vm.isUpcomingStatus && vm.booking.status !== 'DECLINED' && vm.weightLossPrescriptionNumber || (vm.isWeightLossPrescription && vm.booking.status !== 'DECLINED' && !vm.weightLossPrescriptionNumber)">
				<button id="saveNotifyPrescriptionButton" class="c-button c-button--fit c-button--s1 c-button--narrow" [disabled]="vm.loading || !vm.initialized" (click)="vm.handleFormSubmit(mainForm, true)">{{ 'Modal.Button.Save_And_Notify' | translate }}</button>
			</div>
		</div>
		<div *ngIf="vm.booking.status === 'RESERVED'" class="o-grid o-grid--wrap o-grid--xs o-grid--right" [ngClass]="{'u-opaque': vm.loading, 'u-hidden': !vm.initialized}">
			<div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-100 u-ost-xs u-osb-xs" *ngIf="vm.isReservedBooking">
				<button id="cancelReservedBookingButton" class="c-button c-button--fit c-button--s13 c-button--narrow" [disabled]="vm.loading || !vm.initialized" (click)="vm.handleReservedBookingCancel()">{{ 'Modal.Button.Delete_Booking' | translate }}</button>
			</div>
		</div>
	</div>
</form>
